'use strict';

var React = require('react');
var Image = require('@swiggy-private/dls-web-core/dist/components/Image');
var index_es$1 = require('./index.es-55fa6858.js');
var index_es = require('./index.es-8c72aff8.js');
var WidgetController_type = require('./WidgetController/type.js');
var WidgetControllerContext = require('./WidgetControllerContext-924d4968.js');
var styled = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const Button = styled__default['default'].button({
    color: "inherit",
    font: "inherit",
    margin: "0",
    background: "transparent",
    border: "none",
    outline: "none",
    padding: "0",
    appearance: "none",
    display: "flex",
});

const ImageCardInfo = ({ imageId, height, width, cloudinaryImageHeight, cloudinaryImageWidth, action, id, position, analytics, accessibility, }) => {
    const { sdk, clickAnalytics, impressionAnalytics } = React.useContext(WidgetControllerContext.WidgetControllerContext);
    React.useEffect(() => {
        if (!index_es.N(analytics)) {
            if (!index_es.N(analytics.impressionObjectName) && !index_es.N(impressionAnalytics)) {
                impressionAnalytics({
                    action: analytics.impressionObjectName,
                    category: analytics.screenName,
                    label: analytics.objectValue,
                    value: position,
                    context: analytics.context,
                });
            }
        }
    }, [impressionAnalytics, analytics, position]);
    const onImageClick = React.useCallback(() => {
        if (!index_es.N(analytics)) {
            if (!index_es.N(analytics.clickObjectName) && !index_es.N(clickAnalytics)) {
                clickAnalytics({
                    action: analytics.clickObjectName,
                    category: analytics.screenName,
                    label: analytics.objectValue,
                    value: position,
                    context: analytics.context,
                });
            }
        }
        if (action && sdk) {
            const navigateToScreenParams = {
                type: action.type || index_es$1.N.DEEPLINK,
                link: action.link || "",
            };
            if (action.bridgeType === WidgetController_type.BridgeType.NAVIGATE_TO_SCREEN || index_es.N(action.bridgeType)) {
                sdk.navigateToScreen(navigateToScreenParams).catch(() => undefined);
            }
            else {
                sdk[action.bridgeType](action.payload).catch(() => undefined);
            }
        }
    }, [action, analytics, clickAnalytics, position, sdk]);
    return (React__default['default'].createElement(Button, { onClick: onImageClick, "aria-label": accessibility === null || accessibility === void 0 ? void 0 : accessibility.altTextCta, type: "button", "data-testid": `image-click-${id}` },
        React__default['default'].createElement(Image.Image, { cloudinaryId: imageId, height: height, width: width, cloudinaryHeight: cloudinaryImageHeight, cloudinaryWidth: cloudinaryImageWidth, alt: accessibility === null || accessibility === void 0 ? void 0 : accessibility.altText })));
};
var ImageCardInfo$1 = React__default['default'].memo(ImageCardInfo);

exports.ImageCardInfo = ImageCardInfo$1;
//# sourceMappingURL=ImageCardInfo-53b68c09.js.map
